import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { ParmedApiService as ParmedApi } from '../api/parmed-api.service';
import { CMSPages, BUID } from '../constants/app.constant';
import { CmsContent, CmsContentField, MultipleCarousel, CallToAction, MultipleCallToAction, StaticPageContent, ContentStructureDetails, RecordList} from '../../shared/models/cms';
import * as _ from 'lodash';
import { AppUtilService } from '../utils/app-util.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
 
  isFromFeaturedItems = new BehaviorSubject<boolean>(false);

  prepareFooterStaticContents(staticPageContent: StaticPageContent): string[] {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    let htmlContent: string[]  = new Array<string>(2);

    htmlContent[0] = this.processHtmlContentforHashTag(data.recordList[0].description);
    htmlContent[1] =  this.processHtmlContentforHashTag(data.recordList[1].description);

    return htmlContent;
  }

  prepareNotificMsg(staticPageContent: StaticPageContent): string {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    let htmlContent: string = this.processHtmlContentforHashTag(data.recordList[0].description);
    const isCustomerAsscociationExists = this.userService.isAssociationExists();
    const UserCustomerRef = isCustomerAsscociationExists?.userCustomerXrefs;
    if(htmlContent.includes('To access the Flu Portal') && UserCustomerRef.length === 0) {
      // Parse HTML content
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');

      // Remove the specific part
      const partToRemove = doc.querySelector('a[href^="https://flucare"]');
      if (partToRemove) {
        const parentElement = partToRemove.parentElement;
        if (parentElement) {
          const previousElement = partToRemove.previousElementSibling;
          if (previousElement && previousElement.textContent.trim() === 'To access the Flu Portal') {
            parentElement.removeChild(previousElement);
          }
          parentElement.removeChild(partToRemove);
        }
      }

      // Get the modified HTML content
      htmlContent = doc.body.innerHTML;
    }
    return htmlContent;
  }
 
  callToActionArrays: any;
  contentArr: any[];
  buttonLinksDocURLs: any;
  docURLsIndex: any;
  constructor(
    private http: HttpService,  private api: ParmedApi,
    private sanitizer: DomSanitizer,
    private userService: UserService
  ) { }

  getCmsContentByPageNameAndTemplateNum(pageName: CMSPages, buId: number, templateNum: number) {
    return this.http.get(this.api.CMS.GET_CMS_CONTENT_TEMPLATE_URL+'/'+ buId + '/'+ pageName +'/'+ templateNum);
  }

  getCmsStaticPageTemplateByPageNameAndTemplateNum(pageName: CMSPages, buId: number, templateNum: number, sequenceNumber: number){
    return this.http.get(this.api.CMS.GET_CMS_CONTENT_CATEGORY_URL + '/' + buId + '/' + pageName +'/' + templateNum +'/'+ sequenceNumber);
  }

  prepareStaticPageContentsForReturnsPage(staticPageContent: StaticPageContent) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
     //First eletement is for header
     let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<div style="border-bottom: solid 1px #d7dee1;"><h2 style="padding: 20px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title + '</span></h2></div>';
    htmlContent += '<div style="padding-top:15px;">';
   
    for( let i = 0; i < data.recordList.length; i++){
      htmlContent += data.recordList[i].description;
    }
    htmlContent += '</div>';
    htmlContent = this.sanitizer.bypassSecurityTrustHtml(this.processHtmlContentforHashTag(htmlContent)) as string;
    return htmlContent;
  }

  // Process html for Hashtag
  processHtmlContentforHashTag(str: string) {
    let processedContent: string = '';
    let splitStr = str.split(/href="##/);
    if (splitStr.length >= 2) {
      processedContent += splitStr[0];
      for (let i = 0, j = i + 1; i < splitStr.length - 1; i++) {
        j = i + 1;
        processedContent += 'id = hyperlink-' + splitStr[j];
      }
    }
    return splitStr.length >= 2 ? processedContent : str;
  }

  // Download the document from Hash Tag Num
  downloadDocumentFromHashTagNum(documentNum: any) {
    this.getCmsMediaByDocNum(documentNum).subscribe((response: any) => {
      if (!response.hasError) {
        const documentURL = response.mediaLink;
        if (documentURL) {
          AppUtilService.redirectToExternalLink(documentURL);
        }
      }
    });
  }

  prepareStaticPageContents(staticPageContent: StaticPageContent) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
     //First eletement is for header
     let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 20px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title + '</span></h1></div>';
    htmlContent += '<div style="padding-top:15px;"><mat-card><mat-card-content>';
   
    
    for( let i = 0; i < data.recordList.length; i++){
      htmlContent += data.recordList[i].description;
    }
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }

  prepareGenericStaticPageContents(staticPageContent: StaticPageContent) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    //First eletement is for header
    let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 10px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title  + '</span></h1>';
    htmlContent += (headerElement.description == '') ? '': ('<div style="padding-bottom: 20px;">' + headerElement.description + '</div>');
    htmlContent += '</div><div style="padding-top:15px;"><mat-card><mat-card-content>';    
    htmlContent += '<div id="content-wrapper"style="padding-top: 20px;">';
    
    //start iterating from index 1
    for ( let i = 1; i < data.recordList.length; i++){
      htmlContent += data.recordList[i].description;
    }
    htmlContent += '</div>';
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }

  prepareSubscriptionsStaticPageContents(staticPageContent: StaticPageContent) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    //First eletement is for header
    let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 10px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title  + '</span></h1>';
    htmlContent += (headerElement.description == '') ? '': ('<div style="padding-bottom: 20px;">' + headerElement.description + '</div>');
    htmlContent += '</div><div style="padding-top:15px;"><mat-card><mat-card-content>';    
    htmlContent += '<div id="content-wrapper"style="padding-top: 20px;">';
    
    //start iterating from index 1
    for ( let i = 1; i < data.recordList.length; i++) {
      //This is very specific. Need to add section in CMS template to place the div ids
      //TODO: title field is re-used for div for this
      htmlContent +=  ('<div ' + ((data.recordList[i].title == "terms-and-conditions") ? ('id="terms-and-conditions"') : '') + '>');
      htmlContent += data.recordList[i].description;
      htmlContent += '</div>';
    }
    htmlContent += '</div>';
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }

  /**
   * TODO: The HTML template needs to be handled as component - html for template and compent 
   */
  prepareNewsStaticPageContents(staticPageContent: StaticPageContent, buId: number) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    //First eletement is for header
    let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 10px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title 
    + '</span></h1><div style="padding-bottom: 20px;">' + headerElement.description + '</div></div>';
    htmlContent += '<div style="padding-top:15px;"><mat-card><mat-card-content>';    
    htmlContent += '<div id="content-wrapper"style="padding-top: 20px;">';
    //remove first item
    data.recordList.splice(0, 1);

    htmlContent += this.prepareTiledLayout(data.recordList, 2.4, buId);
    htmlContent += '</div>';
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }


  /**
   * TODO: The HTML template needs to be handled as component - html for template and compent 
   */
  prepareProductServicesStaticPageContents(staticPageContent: StaticPageContent, buId: number) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    //First eletement is for header
    let headerElement: RecordList = data.recordList[0];

    //second element for One liner subtitle
    let oneLinerlement: RecordList = data.recordList[1];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 10px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title 
    + '</span></h1><div style="padding-bottom: 20px;">' + headerElement.description + '</div></div>';
    htmlContent += (oneLinerlement.description =="") ? "" : '<div style="margin-top:20px;">' + oneLinerlement.description + '</div>';
    htmlContent += '<div style="padding-top:15px;"><mat-card><mat-card-content>';    
    htmlContent += '<div id="content-wrapper"style="padding-top: 20px;">';

    //remove first 2 items
    data.recordList.splice(0, 2);
    //ParMed has 2 cloumns and Major has 3 cloumns

    let noOfCloumns = (buId == BUID.ParMed) ? 2 : 3;
    htmlContent += this.prepareTiledLayout(data.recordList, noOfCloumns, buId);
    htmlContent += '</div>';
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }

  prepareButtonLiksStaticPageContents (staticPageContent: StaticPageContent, buId: number) {
    let data: ContentStructureDetails = JSON.parse(staticPageContent.contentStructure);
    //First eletement is for header
    let headerElement: RecordList = data.recordList[0];

    let htmlContent: string = '<br><div style="border-bottom: solid 1px #d7dee1;"><h1 style="padding: 10px 0 0 0 !important"><span class="headerColor" style="font-weight:600;font-size: 36px !important;">' + headerElement.title 
    + '</span></h1><div style="padding-bottom: 20px;">' + headerElement.description + '</div></div>';
    
    htmlContent += '<div style="padding-top:15px;"><mat-card><mat-card-content>';    
    htmlContent += '<div id="content-wrapper"style="padding-top: 20px;">';

    //remove first items
    data.recordList.splice(0, 1);

    htmlContent += this.prepareButtonAndTitleLayout(data.recordList, buId);
    htmlContent += '</div>';
    htmlContent += '</mat-card></mat-card-content></div><br><br>';
    
    //this is to set URLs asysnchronously after feching
    setTimeout(() => {this.setDocumentURLs()}, 500);
    htmlContent = this.processHtmlContentforHashTag(htmlContent);
    return htmlContent;
  }

  setDocumentURLs() {
    if (this.docURLsIndex) {
        this.docURLsIndex.forEach((value: boolean, key: string) => {
        let docNum = this.docURLsIndex[key];
        let hrefElement = <HTMLAnchorElement> document.getElementById(key + '-cms-media-doc-' + docNum);
        if (hrefElement != undefined && hrefElement != null) {
          hrefElement.href = this.buttonLinksDocURLs[docNum];
        }
      });
    }
  }

  prepareButtonAndTitleLayout( recordList: RecordList[], buId:number) {
    let htmlContent ='';
    for (let i = 0; i < recordList.length; i++) {
      let record: RecordList = recordList[i];
      let docUrl = this.extractDocAndSetURL(i, record);
      htmlContent+= '<p><a href="' + docUrl + '" target="_blank" '+ this.setDocumentId(i, record.documentNum) + '><span class="btn" style = "background-color: #007ac3; color: white;">' + record.Button + '</span></a></p><p>' + this.detectAndProcessHashtag(record.description) + '</p>';
    }
    return htmlContent;
  }
  //detect and process hashtag num
  detectAndProcessHashtag(htmlContent:string){
    let processedContent: string = htmlContent;
    return processedContent;
  }
  
  /**
   * @param record The line item from CMS Row configuration
   */
  extractDocAndSetURL(index: number, record: RecordList) {
    let url:string = "#";
    if (record.targetlink != null && record.targetlink != "") {
      url = record.targetlink;
    } else if (record.documentNum != null && record.documentNum != 0) {
      if (!this.docURLsIndex) {
        this.docURLsIndex = [];
      }
      if (!this.buttonLinksDocURLs) {
        this.buttonLinksDocURLs = [];
      }
      this.docURLsIndex[index] = record.documentNum;
      //duplicate call will not go only if prev call already fetched the url 
      if (this.buttonLinksDocURLs.indexOf(record.documentNum) == -1) {
          this.getCmsMediaByDocNum(record.documentNum).subscribe((response:any) => {
            let mediaURL = response.mediaLink;
            let docNum:number = response.mediaNum;
            this.buttonLinksDocURLs[docNum] = mediaURL;
        });
      }
    }
    return url;
  }

  setDocumentId(index: number, docNum:number) {
    return (docNum != 0) ? 'id="' + index + '-cms-media-doc-' + docNum + '"' : '';
  }


  prepareTiledLayout( recordList: RecordList[], noOfCloumns: number, buId) {
    let htmlContent ='';
    //iterate further from index 1
    let columnsTiles = '';
    for ( let i = 0; i < recordList.length; i++) {      
      columnsTiles += this.prepareTileHTML(recordList[i], noOfCloumns, buId);
      if ((i+1) % noOfCloumns == 0) {
        htmlContent += '<div class="row">' + columnsTiles + '</div>';
        columnsTiles = '';
      }
    }
    //last column
    if (columnsTiles != '') {
      htmlContent += '<div class="row">' + columnsTiles + '</div>';
    }
    return htmlContent;
  }

  prepareTileHTML(recordListItem: RecordList, noOfCloumns: number, buId: number) {
    //Bootstrap Grid system
    let bootstrapColumn = (12 / noOfCloumns);
    
    //TODO: use theme specific CSS background-color - primary color
    let primaryColor = (buId == BUID.ParMed) ? '#005180':'#005eb8';
    let padding = (buId == BUID.ParMed) ? '5px 10px':'10px 20px';
    return '<div class="col-md-'+ bootstrapColumn +'"><div class="list-group"><div class="list-group-item primary-color" style="font-size: 20px; background-color:' 
    + primaryColor + '; color: white;font-weight: bold;text-align: center; padding:' + padding +'">'
    + recordListItem.title + '</div> <div class="list-group-item" style="min-height: 150px; height:auto; margin-left: 1px;margin-right: 1px;line-height: 1.75em;">' 
    + recordListItem.description + '</div> </div></div>';
  }

  prepareCarouselImages(carouselImageArrays): MultipleCarousel {
    const carousel: MultipleCarousel = {
      media: [],
      rotationalDelay: 0,
    };

    if (carouselImageArrays.length > 0) {
      const sortedCarouselImages: CmsContent[] = _.orderBy(
        carouselImageArrays,
        [CmsContentField.RowUpdateStamp],
        'desc'
      );
      const homePageCarousels = sortedCarouselImages[0];

      homePageCarousels.contentStructureJson = JSON.parse(
        homePageCarousels.contentStructure
      );
      carousel.rotationalDelay = parseInt(
        homePageCarousels.contentStructureJson.rotationalDelay,
        0
      );
      homePageCarousels.contentStructureJson.imageList = homePageCarousels.contentStructureJson.imageList.filter(
        (data) => data.mediaUrl
      );
      homePageCarousels.contentStructureJson.imageList.forEach((data) => {
        carousel.media.push({
          mediaUrl: data.mediaUrl,
          targetlink: data.targetlink,
          staticPage: data.staticPage,
          documentNum: data.documentNum,
          documentName: data.documentName,
        });
      });
    }
    return carousel;
  }

  redirectBasedOnLinkType(carouselData: any) {
    if (carouselData.targetlink) {
      AppUtilService.redirectToExternalLink(carouselData.targetlink);
    }
    else if (carouselData.documentNum) {
      this.getCmsMediaByDocNum(carouselData.documentNum).subscribe((response: any) => {
        if(!response.hasError){
          const documentURL = response.mediaLink;
          AppUtilService.redirectToExternalLink(documentURL);
        }
      });
    }
  }

  getCmsMediaByDocNum(documentNum: number) {
    return this.http.get(this.api.CMS.GET_CMS_MEDIA_URL + '/' + documentNum);
  }

  private parseContentStructureField(
    callToActionDataArray: CmsContent[]
  ): CmsContent[] {
    if (callToActionDataArray.length > 0) {
      callToActionDataArray = _.orderBy(
        callToActionDataArray,
        [CmsContentField.sequenceNum],
        'desc'
      );
      callToActionDataArray.forEach((adPopUp: CmsContent) => {
        adPopUp.contentStructureJson = JSON.parse(adPopUp.contentStructure);
        adPopUp.increaseImageHeight =
          adPopUp.contentStructureJson.description !== '' ? false : true;
      });
      return callToActionDataArray;
    }
  }

  prepareGenericPoupData(genericPopupArray: CmsContent[]): CmsContent {
    let genericPopup: CmsContent = null;

    if (genericPopupArray.length > 0) {
      const sortedGenericPopups: CmsContent[] = _.orderBy(
        genericPopupArray,
        [CmsContentField.RowUpdateStamp],
        'desc'
      );
      genericPopup = sortedGenericPopups[0];
      genericPopup.contentStructureJson = JSON.parse(
        genericPopup.contentStructure
      );
    }
    return genericPopup;
  }

  prepareAdPoupData(adPopupArray: CmsContent[]): CmsContent[] {
    const adPopUps: CmsContent[] = [];

    if (adPopupArray.length > 0) {
      adPopupArray.forEach((adPopUp: CmsContent, key) => {
        adPopUp.contentStructureJson = JSON.parse(adPopUp.contentStructure);

        adPopUps.push(adPopUp);
      });
    }

    return adPopUps;
  }

  prepareSalePoupData(salePopupArray: CmsContent[]): CmsContent {
    let salePopUp: CmsContent = null;

    if (salePopupArray.length > 0) {
      const sortedSalePopups: CmsContent[] = _.orderBy(
        salePopupArray,
        [CmsContentField.RowUpdateStamp],
        'desc'
      );
      salePopUp = sortedSalePopups[0];
      salePopUp.contentStructureJson = JSON.parse(
        salePopUp.contentStructure
      );
    }
    return salePopUp;
  }
}

